import { NgModule } from '@angular/core';
import {
  NgbAlertModule,
  NgbCollapseModule,
  NgbDatepicker,
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule,
  NgbOffcanvasModule,
  NgbPaginationModule,
  NgbRating,
  NgbToastModule,
  NgbTooltipModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [],
  imports: [
    NgbDropdownModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    NgbModalModule,
    NgbAlertModule,
    NgbToastModule,
    NgbNavModule,
    NgbRating,
    NgbDatepicker,
    NgbCollapseModule,
    NgbTooltipModule,
    NgbOffcanvasModule,
  ],
  exports: [
    NgbDropdownModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    NgbModalModule,
    NgbAlertModule,
    NgbToastModule,
    NgbNavModule,
    NgbRating,
    NgbDatepicker,
    NgbCollapseModule,
    NgbTooltipModule,
    NgbOffcanvasModule,
  ],
})
export class NgBootstrapModule {}
